var _polygon, _polygon2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdFGrisRetirerStructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.4,12.3 9.5,12.3 11.6,10 7.4,10 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.8,5.4 13.1,5.4 13.1,7.6 13.8,7.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6,5.7L23,2l-1.4-1.3L2.2,22l1.4,1.3l5.8-6.4h1.4v-1.6l2.8-3.1h3V10h-0.9L18,7.6c2,0.1,3.4,1.8,3.3,3.8 c-0.1,1.8-1.6,3.3-3.5,3.3h-4.6v2.2h4.6c3.2,0,5.8-2.5,5.8-5.7C23.6,8.7,22,6.5,19.6,5.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3,14.7h-1c-2,0.1-3.6-1.4-3.8-3.4s1.4-3.6,3.4-3.8c0.1,0,0.3,0,0.4,0h4.6V5.4H6.3c-3.2,0-5.8,2.5-5.8,5.7 c0,2.9,2.1,5.3,4.9,5.7L7.3,14.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdFGrisRetirerStructure);
export default __webpack_public_path__ + "static/media/CdF_gris_retirer-structure.cd0f70d1.svg";
export { ForwardRef as ReactComponent };